import { DataGrid, GridColDef, deDE } from '@mui/x-data-grid';
import { Box, Typography, Grow, Alert } from '@mui/material';
import React, { useState } from 'react';
import { GlobalMailEdit } from './GlobalMailEdit';
import { useGetGlobalMails } from '../../hooks/reactQuerys/GlobalMailQueries';
import { IGlobalMail } from '../../Interfaces/IGlobalMail';

const options: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

const columns: GridColDef<IGlobalMail>[] = [
  { field: 'idGlobalMail', headerName: 'Nr.', width: 90 },
  {
    field: 'Send_at',
    headerName: 'Vom',
    width: 250,
    renderCell: params =>
      params.value
        ? new Date(params.value).toLocaleString('de-DE', options)
        : '',
  },
  { field: 'Title', headerName: 'Bezeichnung', flex: 1 },
  { field: 'Correct', headerName: 'Erfolgreich', width: 110 },
  { field: 'Error', headerName: 'Fehlerhaft', width: 110 },
  { field: 'Total', headerName: 'Total', width: 90 },
];

export const GlobalMailList: React.FC = () => {
  const { globalMails = [], isLoadingGlobalMails } = useGetGlobalMails();
  const [editId, setEditId] = useState<number | null>(null);

  if (isLoadingGlobalMails) {
    return <Alert severity="info">Rundmails werden geladen …</Alert>;
  }

  return (
    <>
      {/* Edit-Bereich */}
      <Grow in={editId !== null}>
        <Box sx={{ mb: 3 }}>
          {editId !== null && (
            <GlobalMailEdit
              key={`mail-${editId}`}
              currentId={editId}
              setCurrentId={setEditId}
              currentArray={globalMails}
              setCurrentArray={() => {}}
              setWasSaved={() => {}}
              setWasSavedSuccesfully={() => {}}
            />
          )}
        </Box>
      </Grow>

      {/* Tabelle */}
      <Typography variant="h5" sx={{ mt: 2 }}>
        Bisherige Rundmails
      </Typography>

      <DataGrid
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        rows={globalMails}
        columns={columns}
        getRowId={row => row.idGlobalMail}
        onRowClick={params => setEditId(Number(params.id))}
        sx={{ mt: 2, height: 600 }}
      />
    </>
  );
};
